"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = best;

function best(array, scorer) {
  return array.reduce(function (best, item, index) {
    var score = scorer.call(array, item, index);

    if (score > best.score) {
      return {
        index: index,
        score: score
      };
    } else {
      return best;
    }
  }, {
    index: -1,
    score: -Infinity
  }).index;
}